/**
 * MİLYEMSOFT amblem — zarif, ince stroke, prestijli monogram (v2).
 * Lüks saat/mücevher markası estetiği: hairline daire + ince MS + tek nokta.
 */
export default function MSLogo({ size = 40, withGlow = false, className = "" }) {
  const gid = `msLux-${size}`;
  return (
    <div
      className={`inline-flex items-center justify-center relative ${className}`}
      style={{ width: size, height: size }}
      data-testid="ms-logo"
    >
      {withGlow && (
        <div
          aria-hidden
          className="absolute inset-0 blur-md opacity-30"
          style={{ background: "radial-gradient(circle, #D4AF37 0%, transparent 65%)" }}
        />
      )}
      <svg viewBox="0 0 64 64" width={size} height={size} className="relative">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#E6C15E" />
            <stop offset="60%" stopColor="#C89B2B" />
            <stop offset="100%" stopColor="#A47F1E" />
          </linearGradient>
        </defs>
        <circle cx="32" cy="32" r="29" fill="none" stroke={`url(#${gid})`} strokeWidth="0.6" opacity="0.55" />
        <g fill="none" stroke={`url(#${gid})`} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M 13 46 L 13 20 L 22 34 L 31 20 L 31 46" />
          <path d="M 51 22 C 51 19, 46 18, 42 18 C 37 18, 34 21, 34 25 C 34 30, 40 30, 45 32 C 50 34, 51 37, 51 40 C 51 44, 47 46, 43 46 C 39 46, 34 45, 34 42" />
        </g>
        <circle cx="55" cy="12" r="1.1" fill={`url(#${gid})`} />
      </svg>
    </div>
  );
}
